export const DOWNLOADABLE_EXTENSIONS = new Set([
  'pdf',
  'docx',
  'doc',
  'png',
  'jpg',
  'gif',
  'svg',
  'bmp',
  'webp',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'dwg',
  'mpp',
  'zip'
]);

export const ITEM_TYPE = {
  FILE: 'file',
  FOLDER: 'folder'
};